import styles from './hidden-data.module.scss';

export const HiddenData = () => {
  return <div className={styles.hidden} />;
};
